<div class="question-area margin-top-10">
    <div class="row">
        <div class="col-sm-6">
            <h1>
                Question {{itemNum + 1}}
            </h1>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            {{item.QuestionText}}
        </div>
    </div>
</div>
<div *ngFor="let answer of item.Answers" class="row">
    <app-quiz-answer (myEvent)="clearAnswers()" [answer]="answer"></app-quiz-answer>
</div>